(() => {
  const FIXED_LUCKY_CODE = 'LUCKY20';
  const popup = document.querySelector('[data-pizzannu-lucky-offer]');
  if (!popup || popup.dataset.designMode === 'true') return;

  const triggerMode = popup.dataset.triggerMode || 'auto';

  // Persist the first display across product pages and future visits in this browser.
  const seenKey = 'pizzannu-lucky-offer-seen';
  const legacyDismissedPrefix = 'pizzannu-lucky-offer-shown:';
  const legacyClaimedPrefix = 'pizzannu-lucky-offer-claimed:';
  let storage = window.localStorage;
  try {
    const probeKey = '__pizzannu_lucky_offer_probe__';
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
  } catch (_) {
    storage = window.sessionStorage;
  }
  const hasLegacyState = (prefix) => Object.keys(window.sessionStorage).some((key) => key.startsWith(prefix));
  const gift = document.querySelector('[data-lucky-reopen]');
  const code = popup.querySelector('[data-lucky-code]');
  const apply = popup.querySelector('[data-lucky-apply]');
  const copy = popup.querySelector('[data-lucky-copy]');
  let elapsed = 0;
  let lastVisibleAt = Date.now();
  let timer;

  const prepareOffer = () => {
    code.textContent = FIXED_LUCKY_CODE;
    apply.href = `/discount/${encodeURIComponent(FIXED_LUCKY_CODE)}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
  };
  const close = () => {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    gift.hidden = triggerMode !== 'auto';
    window.clearInterval(timer);
  };
  const open = () => {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    gift.hidden = true;
    prepareOffer();
    popup.querySelector('[data-lucky-close]')?.focus();
  };
  const countVisibleTime = () => {
    const now = Date.now();
    if (document.visibilityState === 'visible') elapsed += now - lastVisibleAt;
    lastVisibleAt = now;
    if (elapsed >= 10000) {
      window.clearInterval(timer);
      storage.setItem(seenKey, '1');
      open();
    }
  };

  // Visitors who saw the earlier product-level offer should not receive a new popup.
  if (!storage.getItem(seenKey) && (hasLegacyState(legacyDismissedPrefix) || hasLegacyState(legacyClaimedPrefix))) storage.setItem(seenKey, '1');

  if (triggerMode === 'auto' && !storage.getItem(seenKey)) {
    document.addEventListener('visibilitychange', () => { lastVisibleAt = Date.now(); });
    timer = window.setInterval(countVisibleTime, 500);
  } else if (triggerMode === 'auto') {
    gift.hidden = false;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href="#open-black-friday-offer"]');
    if (!trigger) return;
    event.preventDefault();
    open();
  });

  popup.querySelectorAll('[data-lucky-close]').forEach((button) => button.addEventListener('click', close));
  gift?.addEventListener('click', open);

  copy?.addEventListener('click', async () => {
    const value = code.textContent;
    if (!value) return;
    try { await navigator.clipboard.writeText(value); copy.textContent = 'Copied'; }
    catch { copy.textContent = value; }
  });
})();
